import { useState } from "react";
import FolderIcon from "../../../../../assets/icons/FolderIcon";
import TrashIcon from "../../../../../assets/icons/TrashIcon";
import Message from "../../../../../i18n/Message";
import "./AssetItem.scss";

const shortenName = (name) => {
  if (name && name.length > 25) {
    return name.substring(0, 22) + "...";
  }
  return name;
};

const FolderAssetItem = ({ asset, onClick, onDelete }) => {
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

  const handleDelete = (e) => {
    e.stopPropagation();
    setShowDeleteConfirm(true);
  };

  const handleDeleteConfirm = (e) => {
    e.stopPropagation();
    setShowDeleteConfirm(false);
    onDelete && onDelete(asset);
  };

  const handleCancelDelete = (e) => {
    e.stopPropagation();
    setShowDeleteConfirm(false);
  };

  const handleClick = (e) => {
    if (!showDeleteConfirm) {
      onClick(e);
    }
  };

  return (
    <div className="asset_list_item" onClick={handleClick}>
      <div className="item_icon">
        <FolderIcon color="rgb(145,155,173)" size={48} strokeWidth="1.5" />
      </div>
      <div className="item_name">{shortenName(asset.name)}</div>

      <div className="item_overlay">
        <div className="overlay_content">
          <button
            className="btn btn-danger btn-sm delete_button"
            onClick={handleDelete}
          >
            <TrashIcon size="20" color="#fff" />
          </button>
        </div>
      </div>

      {showDeleteConfirm && (
        <div className="confirm_container" onClick={(e) => e.stopPropagation()}>
          <div className="cover" onClick={handleCancelDelete}></div>
          <div className="confirm_panel">
            <button
              className="btn bg-gradient-primary btn-sm"
              onClick={handleDeleteConfirm}
            >
              <Message id="confirm_delete" />
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default FolderAssetItem;
